/**
 * @generated SignedSource<<88e92bb3e705bc0c7a726d3fa65d7fdc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RatecardProjectSidebar_ratecardProject$data = {
  readonly editMode: boolean;
  readonly id: string;
  readonly projectName: string | null;
  readonly validation: {
    readonly allSuccessful: boolean | null;
    readonly errorMessage: string | null;
    readonly otherInformation: string | null;
    readonly ratecard: string | null;
    readonly supplierSelection: string | null;
    readonly tenderPlanning: string | null;
  } | null;
  readonly " $fragmentType": "RatecardProjectSidebar_ratecardProject";
};
export type RatecardProjectSidebar_ratecardProject$key = {
  readonly " $data"?: RatecardProjectSidebar_ratecardProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"RatecardProjectSidebar_ratecardProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RatecardProjectSidebar_ratecardProject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RatecardProjectValidationNode",
      "kind": "LinkedField",
      "name": "validation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tenderPlanning",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supplierSelection",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ratecard",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "otherInformation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allSuccessful",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RatecardProjectNode",
  "abstractKey": null
};

(node as any).hash = "95477d9805abcb0cde5298bcdce2e65d";

export default node;
